import { map, tap } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { environment } from '../../../environments/environment';
import { FieldActivityMultiple } from '../_models/fieldActivityMultiple';
import { CropMetricsService } from './cropMetrics.service';
import { FieldActivity } from '../_models';
import { FeatureFlagService } from './featureFlag.service';
import { FieldActivityStatistics } from '../_models/fieldActivityStatistics';

@Injectable()
export class FieldActivityMultipleService {
  private apiBaseUrl = environment.apiBaseUrl;
  ItemObj: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private cropMetricsService: CropMetricsService,
    private featureFlagService: FeatureFlagService
  ) {}

  getFieldActivityMultiple(uuid): Observable<FieldActivity[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v2/fieldActivityMultiple?uuid=' + uuid)
      .pipe(map((response) => response));
  }

  savefieldActivityMultiple(fieldActivityElement, strategy, noFieldActivity): Observable<any> {
    const fieldActivity = { ...fieldActivityElement };
    delete fieldActivity.lastUpdated;
    delete fieldActivity.dateCreated;
    delete fieldActivity.cropObj;
    const dateFormatted = moment(fieldActivity.activityDate).startOf('day').utc().toISOString();
    fieldActivity.activityDate = dateFormatted ? dateFormatted.replace(':00Z', ':00.000Z') : '';

    if (fieldActivity.mixes && fieldActivity.mixes.length > 0) {
      const arrmixes: Array<any> = [];
      fieldActivity.mixes.forEach((element) => {
        if (element && element.product) {
          const idproduct: any = {
            id: element.product.id,
          };
          element.product = idproduct;
        }
        // var idmixe:any = {
        //     'product':idproduct
        // };
        arrmixes.push(element);
      });
      fieldActivity.mixes = arrmixes;
    }
    if (fieldActivity.equipments) {
      const arrequipments: Array<any> = [];
      fieldActivity.equipments.forEach((element) => {
        const idequipment: any = {
          id: element.id,
        };
        arrequipments.push(idequipment);
      });
      fieldActivity.equipments = arrequipments;
    }
    if (fieldActivity.users) {
      const arrusers: Array<any> = [];
      fieldActivity.users.forEach((element) => {
        const iduser: any = {
          id: element.id,
        };
        arrusers.push(iduser);
      });
      fieldActivity.users = arrusers;
    }

    if (fieldActivity.field) {
      const idfield: any = {
        id: fieldActivity.field.id,
      };
      fieldActivity.field = idfield;
    }
    delete fieldActivity.verificationDate;
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    fieldActivity.companyId = companySelected ? companySelected.id : null;
    const shouldUseNewActivity = this.featureFlagService.getFlagValue('enable-activity-v3', false);
    const apiVersion = shouldUseNewActivity == true ? 'v3' : 'v2';

    if (fieldActivity.id) {
      const strat = strategy ? '?strategy=' + strategy : '';
      return this.http
        .put(
          this.apiBaseUrl +
            'api/private/' +
            apiVersion +
            '/fieldActivityMultiple/' +
            fieldActivity.id +
            strat,
          fieldActivity
        )
        .pipe(
          map((response: any) => {
            if (response) {
              this.cropMetricsService.getCropMetrics().subscribe();
              if (shouldUseNewActivity == true) {
                return response.data;
              } else {
                return response;
              }
            }
          })
        );
    } else {
      return this.http
        .post(
          this.apiBaseUrl +
            'api/private/' +
            apiVersion +
            '/fieldActivityMultiple?noField=' +
            noFieldActivity,
          fieldActivity
        )
        .pipe(
          map((response: any) => {
            if (response) {
              this.cropMetricsService.getCropMetrics().subscribe();
              if (shouldUseNewActivity == true) {
                return response.data;
              } else {
                return response;
              }
            }
          })
        );
    }
  }

  deleteFieldActivity(fieldActivity): Observable<FieldActivityMultiple> {
    const shouldUseNewActivity = this.featureFlagService.getFlagValue('enable-activity-v3', false);
    const apiVersion = shouldUseNewActivity == true ? 'v3' : 'v2';
    return this.http
      .delete<any>(
        this.apiBaseUrl + 'api/private/' + apiVersion + '/fieldActivityMultiple/' + fieldActivity.id
      )
      .pipe(
        tap(() => {
          this.cropMetricsService.getCropMetrics().subscribe();
        })
      );
  }

  getFieldActivityStatistic(cropYear: number, done: boolean): Observable<FieldActivityStatistics> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v3/fieldActivityMultiple/statistics?cropYear=' +
          cropYear +
          '&done=' +
          done
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
